// Redimensiona las fotos al vuelo con un proxy público (images.weserv.nl) para
// que carguen RÁPIDO. Las fotos originales pesan varios MB; así se sirven en
// WebP liviano (~50 KB) del tamaño que se necesita. Se ven igual, pero el
// catálogo y el inventario cargan muchísimo más rápido (clave en el celular).
export function optimizarFoto(url, ancho = 700) {
  if (!url || typeof url !== 'string' || !/^https?:\/\//i.test(url)) return url || '';
  // weserv no lleva el protocolo en el parámetro url.
  const sinProtocolo = url.replace(/^https?:\/\//i, '');
  return `https://images.weserv.nl/?url=${encodeURIComponent(sinProtocolo)}&w=${ancho}&output=webp&q=82`;
}
